{
  "titles": {
    "REVOLVING_BALANCE": "Carried balances",
    "PURCHASE": "Purchases",
    "SALE": "Sales",
    "DEBT_MOVEMENT": "Debt sales",
    "PAYMENT": "Payments",
    "RECEIPT": "Receipts"
  },
  "products": {
    "DIESEL": "Diesel",
    "PETROL": "Petrol"
  },
  "columns": {
    "number": "Number",
    "date": "Date",
    "postingDate": "Posting date",
    "dateTime": "Date and time",
    "branch": "Branch",
    "employee": "Employee",
    "employeePhone": "Employee phone",
    "cashBalance": "Cash balance",
    "notes": "Notes",
    "barrelPurchasePrice": "Barrel purchase price",
    "jerrycanPurchasePrice": "Jerrycan purchase price",
    "barrelSalePrice": "Barrel sale price",
    "jerrycanSalePrice": "Jerrycan sale price",
    "amount": "Amount",
    "lessJerrycans": "Less jerrycans",
    "finalTotal": "Final total",
    "deliveryStatus": "Delivery status",
    "movementType": "Movement type",
    "debtor": "Debtor",
    "vehicle": "Vehicle",
    "personName": "Person name",
    "statement": "Statement",
    "messageStatus": "Message status",
    "deliveryStatusValue": {
      "PENDING": "Pending Delivery",
      "DELIVERED": "Delivered"
    },
    "source": "Source",
    "priceStatus": "Pricing status",
    "customer": "Customer",
    "deliveredBy": "Delivery employee",
    "pricedBy": "Pricing employee",
    "postingStatus": "Posting status",
    "postingStatusValue": {
      "POSTED": "Posted",
      "PENDING": "Not posted"
    },
    "shiftStatus": "Shift status",
    "closedAt": "Closed on"
  },
  "totals": {
    "sum": "Total",
    "totalBarrels": "Total barrels",
    "totalJerrycans": "Total jerrycans",
    "totalDebit": "Total debit",
    "totalCredit": "Total credit",
    "balance": "Balance"
  },
  "actions": {
    "export": "Export to Excel",
    "exportPdf": "Export to PDF",
    "exportSelectedLimit": "You can export up to {{max}} selected rows. Clear some of the selection.",
    "view": "View",
    "delete": "Delete",
    "confirmDelivery": "Confirm delivery",
    "resendMessage": "Resend message",
    "addManualMovement": "Add manual movement",
    "editMovement": "Edit debt movement",
    "edit": "Edit",
    "reprint": "Reprint",
    "completePrice": "Complete the price"
  },
  "kind": {
    "CHARGE": "Debit",
    "REPAYMENT": "Credit"
  },
  "toolbar": {
    "searchPlaceholder": "Search by number...",
    "searchLabel": "Number",
    "deliveryStatus": "Delivery status",
    "employee": "Employee",
    "debtor": "Debtor",
    "vehicle": "Vehicle",
    "movementType": "Movement type",
    "allStatuses": "All statuses",
    "allEmployees": "All employees",
    "allDebtors": "All debtors",
    "allVehicles": "All vehicles",
    "allTypes": "All types",
    "fixedDayNote": "Shown for your branch's current business date",
    "priceStatus": "Pricing status",
    "allPriceStatuses": "All",
    "postingStatus": "Posting status",
    "allPostingStatuses": "All"
  },
  "deleteConfirm": {
    "title": "Delete {{reference}}?",
    "description": "{{reference}} will be removed from the list and can be restored from Trash. This cannot be undone from this screen."
  },
  "deleteManyConfirm": {
    "title": "Delete {{count}} transactions?",
    "description": "{{count}} transactions will be removed and can be restored from Trash."
  },
  "deliverConfirm": {
    "title": "Confirm delivery of {{reference}}?",
    "description": "{{reference}} will be marked as delivered. This cannot be undone."
  },
  "resendConfirm": {
    "title": "Resend the message?",
    "description": "This transaction's message will be sent to the debtor again."
  },
  "details": {
    "title": "Transaction details {{reference}}",
    "description": "Full transaction detail, lines, participating employees and messages",
    "participants": "Participating Employees",
    "participantRole": {
      "ENTERED_BY": "Entered By",
      "CASH_HANDLED_BY": "Cash Handled By",
      "DELIVERED_BY": "Delivered By",
      "EDITED_BY": "Edited By",
      "DELETED_BY": "Deleted By",
      "RESTORED_BY": "Restored By",
      "PRICED_BY": "Priced By",
      "POSTED_BY": "Posted By"
    },
    "messages": "Messages",
    "lines": "Lines",
    "category": "Category",
    "qty": "Quantity",
    "fraction": "Category value",
    "reference": "Reference",
    "product": "Product",
    "createdAt": "Created At",
    "deletedBy": "Deleted By",
    "deletedAt": "Deleted At",
    "deliveredAt": "Delivered At",
    "id": "ID",
    "employeePhone": "Employee phone",
    "otherJerrycans": "Other jerrycan categories",
    "barrelsTotal": "Total barrels",
    "jerrycansTotal": "Total jerrycans",
    "customersIntegration": "Customers integration",
    "customersDeliveryFailed": "Could not send to Customers"
  },
  "manualMovement": {
    "addTitle": "Add manual movement",
    "editTitle": "Edit debt movement",
    "fields": {
      "branch": "Branch",
      "movementType": "Movement type",
      "debtor": "Debtor",
      "vehicle": "Vehicle",
      "amount": "Amount",
      "barrelPrice": "Barrel Sale Price",
      "jerrycanPrice": "Jerrycan Sale Price",
      "lessJerrycans": "Less jerrycans",
      "notes": "Notes",
      "isPriorBalance": "Prior movements balance?"
    },
    "priorBalanceSuffix": "(prior movements balance)",
    "summary": {
      "title": "Movement summary",
      "totalBarrels": "Total barrels",
      "totalJerrycans": "Total jerrycans",
      "amount": "Amount",
      "finalTotal": "Final total",
      "invalidPhone": "Invalid number: this movement will not reach Customers or WhatsApp.",
      "currentBalance": "Current balance",
      "debtLimit": "Debt limit",
      "fitsLimit": "Within the debt limit",
      "exceedsLimit": "Exceeds the debt limit"
    },
    "quantityGrid": {
      "title": "Quantities (optional, informative only)",
      "barrels": "Barrels",
      "jerrycans": "Jerrycans"
    },
    "confirm": {
      "description": "Review the movement details before saving.",
      "commit": "Save movement",
      "branch": "Branch",
      "product": "Product",
      "movementType": "Movement type",
      "debtor": "Debtor",
      "oldDebtor": "Previous debtor",
      "newDebtor": "New debtor",
      "vehicle": "Vehicle",
      "noVehicle": "No vehicle",
      "amount": "Final total",
      "oldAmount": "Previous amount",
      "newAmount": "New amount"
    },
    "validation": {
      "amountPositive": "Amount must be greater than zero, with at most five decimal places",
      "pricePositive": "Price must be greater than zero, with at most five decimal places",
      "lessJerrycansNonNegative": "Value must be zero or greater, with at most five decimal places",
      "tooManyDecimals": "At most five decimal places are allowed.",
      "vehicleNotOfDebtor": "This vehicle does not belong to the selected debtor"
    },
    "pricesNotPrefilled": "Enter the price manually; you do not have permission to view saved prices",
    "savedPending": "The transaction was saved as pending until it is posted"
  },
  "source": {
    "OPERATOR": "Operations",
    "PDA": "PDA"
  },
  "priceStatus": {
    "PENDING": "Awaiting pricing",
    "PRICED": "Priced"
  },
  "pda": {
    "title": "PDA",
    "customer": "Purchase customer",
    "customerPhone": "Phone number",
    "vehiclePlate": "Vehicle number",
    "vehicleType": "Vehicle type",
    "vehicleNationality": "Vehicle nationality",
    "driverNationality": "Driver nationality",
    "barrels": "Number of barrels",
    "jerrycans": "Number of jerrycans",
    "deducted": "Number of deducted jerrycans",
    "netQuantity": "Net quantity"
  },
  "completePrice": {
    "title": "Complete the price",
    "description": "Enter the purchase prices for transaction {{reference}}. Amounts are computed from the recorded quantities.",
    "toast": "The price was completed",
    "summary": {
      "title": "Transaction summary",
      "totalBarrels": "Total barrels",
      "totalJerrycans": "Total jerrycans",
      "barrelsAmount": "Barrels amount",
      "jerrycansAmount": "Jerrycans amount",
      "amount": "Amount",
      "finalTotal": "Final total",
      "placeholder": "—"
    },
    "confirm": {
      "title": "Confirm save",
      "description": "This purchase will be priced permanently and cannot be priced again.",
      "commit": "Save the price",
      "reference": "Number",
      "product": "Product"
    }
  },
  "posting": {
    "status": "Posting status",
    "time": "Posting time",
    "postedBy": "Posted By",
    "PENDING": "Pending",
    "POSTED": "Posted",
    "forced": "Forced post"
  },
  "shiftStatus": {
    "ACTIVE": "Active",
    "CLOSED": "Closed"
  }
}
